

export const changeLang = (language) =>({
    type: "CHANGE_LANG",
    payload: language,
})